<template>
  <div class=" page-view pt-4 pb-4">
      <div class="container">          
          <div class="row">
            <div class=" news-list ">
              <div class="col-12">
                <h3><div class="tabs-prd-title"> <span >Tin tức</span></div>    </h3>   
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 wow blog-article" v-for="(news, index) of newsList" :key="index">
                  <div class="row" >      
                      <div class="col-lg-4 col-md-4 col-4">
                          <div class="rte">
                              <router-link
                              exact=""
                              :to="{
                              name: 'news',
                              params: { slug: news.seoName }
                              }"
                              >
                              <img v-bind:src="getImageNews(news)" v-bind:title="news.title" />
                              </router-link >
                          </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-8">
                          <div class="article_header">
                              <div class="product_name">
                                  <h3 class="blog-item-name ">
                                      <router-link
                                      exact=""
                                      :to="{
                                      name: 'news',
                                      params: { slug: news.seoName }
                                      }"
                                      >
                                      {{news.title}}
                                      </router-link >
                                  </h3>
                              </div>
                          </div>
                          <div class="blog-summary" v-html="news.description">  </div>            
                      </div>                    
                  </div>
              </div>    	      
            </div>
          </div>
    </div>    
  </div>  
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  import { FETCH_NEWS } from '@/store/actions.type';
  import util from "@/common/util";

  export default {
    name: "RwvNewsList",
    components: {  },
    props: {
    },
    mounted() {
      Promise.all([store.dispatch(FETCH_NEWS)]).then(() => {});
    },
    computed: {
      ...mapGetters(["newsList"])
    },
    methods: {
      getImageNews(data) {
          return util.getImageNews(data.imageURL);
        }
    }
  };
</script>
<style>
.news-list{
  text-align: justify;
}

.news-list .blog-article .rte img{
    object-fit: cover;
    height: 125px;
    object-position: 50% 0;
}
.news-list h3.blog-item-name {
    margin: 0 0 5px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
}
.news-list h3.blog-item-name a{
  color:#333;
}
.blog-article{
  margin-bottom: 20px;
  float:left;
}
.news-list .blog-summary p{
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    margin: 0;
    color: #666;
}
.blog-summary p{
      font-size: 15px;
    height: 81px;
    overflow: hidden;
}
</style>